$(function() {
  const modal = document.getElementById('meuModal');
  // Abrir modal
  $('.my-open-modal').on('click', function() {
    // const modalId = $(this).data('my-modal');
    modal.classList.add('my-active');
    console.log('Modal aberto');
  });

  // Fechar modal ao clicar no botão
  $('.close_button').on('click', function() {
    modal.classList.remove('my-active');
  });

  // Fechar ao clicar no fundo escuro
  $('.my-modal__overlay').on('click', function() {
    modal.classList.remove('my-active');
  });
});
